export enum UserRole {
    Admin = 0,
    Creator = 1,
    Standard = 2,
    RestrictedAccess = 3
}

export interface UserAdInfo {
    key: string;
    name: string;
    givenName: string;
    surName: string;
    mail: string;
    userPrincipalName: string;
    photoUrl: string;
}

export interface User {
    id: string;
    role: UserRole;
    pinnedAgents: string[];
    emailAddress: string;
    loginAddress: string;
    name: string;
    adInfo: UserAdInfo;
    createdDate: string;
    lastLoggedIn: string;
    modifiedDate: string;
}

export interface PaginatedUsers {
    items: User[];
    pageNumber: number;
    pageSize: number;
    totalRecords: number;
}
